import { useState } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { PageTitle } from "../components/site/PageTitle";
import { useSite } from "../context/SiteContext";
import { imgUrl } from "../lib/api";

export default function Work() {
  const { gallery = [] } = useSite();
  const [idx, setIdx] = useState(null);
  const go = (d) => setIdx((i) => (i + d + gallery.length) % gallery.length);
  const cur = idx !== null ? gallery[idx] : null;
  return (
    <div className="pb-20">
      <PageTitle badge="ASAP & Co." title="Our Work" subtitle="Real projects for local businesses, teams, schools and families." testId="work-title" flash />
      <div className="mx-auto max-w-7xl columns-2 gap-4 px-4 sm:px-6 md:columns-3 lg:columns-4" data-testid="work-gallery">
        {gallery.map((g, i) => (
          <button key={g.id} onClick={() => setIdx(i)} className="group mb-4 block w-full overflow-hidden rounded-xl border border-white/10" data-testid={`work-item-${i}`}>
            <img src={imgUrl(g.image)} alt={g.caption} loading="lazy" className="w-full transition-transform duration-500 group-hover:scale-105" />
          </button>
        ))}
      </div>
      {cur && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/95 p-4" onClick={() => setIdx(null)} data-testid="work-lightbox">
          <button className="absolute right-4 top-4 rounded-full bg-white/10 p-2 hover:bg-[#E5202A]" onClick={() => setIdx(null)} data-testid="work-lightbox-close"><X /></button>
          <button className="absolute left-3 rounded-full bg-white/10 p-3 hover:bg-[#E5202A]" onClick={(e) => { e.stopPropagation(); go(-1); }} data-testid="work-lightbox-prev"><ChevronLeft /></button>
          <figure onClick={(e) => e.stopPropagation()} className="max-w-5xl text-center">
            <img src={imgUrl(cur.image)} alt={cur.caption} className="max-h-[80vh] rounded-xl object-contain" />
            {cur.caption && <figcaption className="mt-3 font-display text-lg uppercase text-slate-300">{cur.caption}</figcaption>}
          </figure>
          <button className="absolute right-3 rounded-full bg-white/10 p-3 hover:bg-[#E5202A]" onClick={(e) => { e.stopPropagation(); go(1); }} data-testid="work-lightbox-next"><ChevronRight /></button>
        </div>
      )}
    </div>
  );
}
